import styled from 'styled-components';
import devices from 'src/viewLayer/styling/mixins/media-queries';
import { getColoursFromTheme, Box, Stack } from 'src/viewLayer/components/DesignSystem';
import { getThemeDefaultProps } from 'src/viewLayer/styling/helpers';

export const AppComponentWithBackground = styled(Stack)`
  background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.backgroundColor};
  height: 100%;
  min-height: 100vh;
  /* mobile viewport iphone se bug fix */
  min-height: -webkit-fill-available;
`;

export const LoginBusinessPageContainer = styled(Box)`
  background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.foregroundColor};
  min-height: 100%;
  /* mobile viewport bug fix */
  min-height: -webkit-fill-available;
  @media only screen and ${devices.fromsmall} {
    background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.backgroundColor};
  }
`;

export const ForgotPasswordPageContainer = styled(Stack)`
  background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.foregroundColor};
  flex-grow: 1;
  @media only screen and ${devices.fromsmall} {
    padding-top: 2rem;
  }
`;

export const ForgotPasswordPageCard = styled(Stack)`
  flex-grow: 0.9;
  margin: 0 auto;
  max-width: 30rem;
  @media only screen and ${devices.fromxsmall} {
    max-width: 34rem;
  }
`;



export const ForgotPasswordPageFormContainer = styled(Stack)`
  margin: 0 auto;
  width: 100%;

  @media only screen and ${devices.fromxxsmall} {
    width: 20rem;
  }
  @media only screen and ${devices.fromxsmall} {
    width: 21rem;
  }
`;

export const ResetPasswordPageContainer = styled(Stack)`
  background-color: ${({ theme }) => getColoursFromTheme(theme).authContainer.foregroundColor};
  flex-grow: 1;
  @media only screen and ${devices.fromsmall} {
    padding-top: 2rem;
  }
`;

export const ResetPasswordPageCard = styled(Stack)`
  flex-grow: 0.9;
  margin: 0 auto;
  max-width: 30rem;
  @media only screen and ${devices.fromxsmall} {
    max-width: 34rem;
  }
`;

export const ResetPasswordPageFormContainer = styled(Stack)`
  margin: 0 auto;
  width: 100%;

  @media only screen and ${devices.fromxxsmall} {
    width: 20rem;
  }
  @media only screen and ${devices.fromxsmall} {
    width: 21rem;
  }
`;

export const ForgotPasswordPageTermsContainer = styled(Box)`
  margin: 0 auto;
  width: 100%;
  @media only screen and ${devices.fromxsmall} {
    width: 24.75rem;
  }
`;

export const FooterContainer = styled(Stack)`
  background-color: transparent;
`;

AppComponentWithBackground.defaultProps = getThemeDefaultProps();
